<template>
  <div></div>
</template>

<script>
export default {
  name: "EdDialog",
  components: {},
  data: () => ({
    dialog: false,
    message: null,
    title: null,
    promise: null,
    isAlert: false,
    promiseResolve: () => {},
    promiseReject: () => {},
  }),
  created() {},
  mounted() {
    this.$utilidade.console("::EdConfirmDialog module loaded::");
  },
  methods: {
    confirm(message = "", type = "warning", title = "Atenção") {

      let self = this
      this.promise = new Promise((resolve, reject) => {
        self.$confirm(message, title, {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: type,
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });

      return this.promise;
    },

    alert(message = "", type = "success", title = "Atenção") {
      this.promise = new Promise((resolve, reject) => {
        this.$alert(message, title, {
          confirmButtonText: "OK",
          type: type,
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
      return this.promise;
    },


    reset() {
      this.promise = null;
      this.promiseResolve = null;
      this.promiseReject = null;
      this.message = null;
      this.title = null;
      this.dialog = false;
      //this.$destroy();
    },
  },
};
</script>



// WEBPACK FOOTER //
// EdDialog.vue?47b8e52e